<!-- svelte-ignore a11y-no-onchange -->
<select on:input on:blur on:change bind:value {...$$restProps}>
  <!-- We don't include a null/blank option because we want them to pick one -->
  {#each denominations || [] as denomination}
    {#if denomination === "-"}
      <option disabled="disabled" value="divider">────────────────</option>
    {:else}
      <option value={denomination}>{denomination}</option>
    {/if}
  {:else}
    <option value="">Loading...</option>
  {/each}
</select>

<script lang="ts">
  import { onMount } from 'svelte'
  import axios from 'axios'
  // I would have just imported directly from a JSON file, but that would make it harder to change. (It would require rebuilding the assets, which currently is a slow process.) So we'll fetch it from Rails, which lets us more easily change the data without rebuilding the assets.
  //import denominations from '../../../../../../db/data/denominations.json'

  export let value

  let denominations = []

  onMount(async () => {
    const result = await axios.get(`/denominations`)
    denominations = await result.data
  })
</script>
